import { SelectItem } from '@components/inputs/select/Select.component';
import I18n from '@utils/i18n.utils';

export enum PreAuditType {
  CONTACT = 'CONTACT',
  NEED = 'NEED',
  DATA = 'DATA',
  OBSERVATION = 'OBSERVATION',
}

export enum Data {
  SALES = 'SALES',
  SITE_SIZE = 'SITE_SIZE',
}

export namespace Data {
  export const selectItems = () => [
    { label: I18n.t('global.data.sales'), value: Data.SALES },
    { label: I18n.t('global.data.site_size'), value: Data.SITE_SIZE },
  ];
  export const getLegendDefinition = (value: string) => {
    switch (value) {
      case Data.SALES:
        return I18n.t('global.data.sales');
      case Data.SITE_SIZE:
        return I18n.t('global.data.site_size');
      default:
        return '';
    }
  };
  export const getUnitiy = (value: string) => {
    switch (value) {
      case Data.SALES:
        return '€';
      case Data.SITE_SIZE:
        return 'm2';
      default:
        return '';
    }
  };
}

export namespace PreAuditType {
  export const selectItems = (): SelectItem[] => [
    { label: I18n.t('audits.preAudit.types.contact'), value: PreAuditType.CONTACT },
    { label: I18n.t('audits.preAudit.types.need'), value: PreAuditType.NEED },
    { label: I18n.t('audits.preAudit.types.data'), value: PreAuditType.DATA },
    { label: I18n.t('audits.preAudit.types.observation'), value: PreAuditType.OBSERVATION },
  ];
}
